import { Header } from 'semantic-ui-react';


export const HeaderUi = ({children, ...props}) => {
    return <Header {...props}>
        {children}
    </Header>
}

export default HeaderUi